import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appArrowNavigation]'
})
export class ArrowNavigationDirective {
  @Input('childLevel') childLevel: number = 3;
  @Input('topparentLevel') topparentLevel: number = 5;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    
    const { key } = event;
    let index=0;
    let inputs:any = Array.from(document.querySelectorAll('input:not([disabled])'));
    inputs=[...inputs,...Array.from(document.querySelectorAll('textarea:not([disabled])')),...Array.from(document.querySelectorAll('select'))];
    const currentIndex = inputs.indexOf(this.el.nativeElement);
    let parentElement=this.getParentNLevelsUp(this.el.nativeElement, (this.topparentLevel-1)) as HTMLElement;
    let topparentElement=this.getParentNLevelsUp(this.el.nativeElement, this.topparentLevel) as HTMLElement;
    let parent_row:any;
    if (parentElement) {
      let child=parentElement.children[0];
      index = Array.from(parentElement.children).indexOf(this.getParentNLevelsUp(this.el.nativeElement, this.childLevel));
      
    }
    
    if (key === 'ArrowRight' && currentIndex < inputs.length - 1) {
      event.preventDefault();
      (inputs[currentIndex + 1] as HTMLElement).focus();
      let element =inputs[currentIndex + 1] as HTMLInputElement;
      element.select(); 
      
    }

    if (key === 'ArrowLeft' && currentIndex > 0) {
      
      event.preventDefault();
      (inputs[currentIndex - 1] as HTMLElement).focus();
      let element =inputs[currentIndex - 1] as HTMLInputElement;
      element.select(); 
     
    }

    if (key === 'ArrowDown' && parentElement) {
      
      event.preventDefault();
      if(topparentElement.nextElementSibling)
      {
        parent_row=topparentElement.nextElementSibling?.children[0];
        (parent_row.children[index].querySelector('input') as HTMLElement).focus();
        let element =parent_row.children[index].querySelector('input') as HTMLInputElement;
        element.select(); 
      }
     
      
     
    }
    if (key === 'ArrowUp' && parentElement) {
      
      event.preventDefault();
      if(topparentElement.previousElementSibling)
        {
          parent_row=topparentElement.previousElementSibling?.children[0];
          (parent_row.children[index].querySelector('input') as HTMLElement).focus();
          let element =parent_row.children[index].querySelector('input') as HTMLInputElement;
          element.select(); 
        }
    
    }
  }
  getParentNLevelsUp(element: HTMLElement, n: number): HTMLElement | any {
    let currentElement: HTMLElement | null = element;
    for (let i = 0; i < n; i++) {
      currentElement = currentElement?.parentElement;
      if (!currentElement) return null; // Break if parent is null before reaching the nth level
    }
    return currentElement;
  }
 
}
